import { jsonGet, htmlGet } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import { checkWidth, checkHeight } from '../utilities/utility';

const $doc = $(document);
const clsHidden = 'hidden';
const clsCheckoutPayment = '.checkout_payment_method';
const clsPaymentOptions = '.payment-options';
const clsPaymentSection = `${clsPaymentOptions}__section`;
const clsRadio = `${clsPaymentOptions}__radio`;
const clsPaymentMethod = '.btn-group';
const clsRadioContainer = '.radio-container';
const clsReview = '.review-order__button';
const clsTerms = '.terms-condition';
const clsTermsCheckbox = '.terms-condition-custom-checkbox';
const clsShowTermsCondition = '.show-checkout-terms-condition';
const clsCreditDropdown = '.credit-dropdown';
const clsPreselected = '.preselected-value';
const clsPaymentMessage = '.payment-message';
const clsPaymentErrorMessage = '.payment-error-msg';
const clsRevSpringContainer = 'iframe#external-iframe-RevSpring';
const clsPaymentInfo = '.payment_information';
const clsDropdown = '.dropdown-menu li';
const clsTermConditionModal = '.terms-condition-modal';
const clsTermConditionParent = 'terms-condition-container-parent';
const eCheck = 'eCheck';
const credit = 'credit';
const hra = 'HRA';
const statement = 'Statement';
const editButton = '.editClass';
const removeButton = '.removeClass';
const reviewButton = '.review-order__button';
const success = 'SUCCESS';
const error = 'ERROR';
const cboxTitle = '#cboxTitle';
const cboxParent = '#colorbox';
const cboxLoadedContent = '#cboxLoadedContent';
const cboxOverlay = '#cboxOverlay';
const creditMode = 'CARD';
const echeckMode = 'ACH';
const clsErrorMessage = 'error-message-text';
const clsTermsCondition = '#checkoutTermsConditionModal';
const dataInfoMessage = 'data-info-message';
const paymentOption = '#paymentOption';
const walletId = '#walletId';
const cardNetwork = '#cardNetwork';
const cardAccountNumber = '#cardAccountNumber';
const cardAccountHolderName = '#cardAccountHolderName';
const cardCardType = '#cardCardType';
const financialInstitution = '#financialInstitution';
const cardExpirationMonth = '#cardExpirationMonth';
const cardExpirationYear = '#cardExpirationYear';
const reviewOrderForm = '#reviewOrderForm';
const undetermined = 'Undetermined';
const pmtOptionCard = '.payment-option__card';
const orderTotal = '.order-details__total';
const nullOrder = 0.0;
const clsChaseContainer = '.chase_modal_container';
const clsPaymentOrderContainer = '.payment_order_container';
const clsChaseErrorMessage = '.chase-error-text';
const clsChaseErrorContainer = '.chase-error-message-container';
const constHidden = 'hidden';
const clsCheckWalletFlag = '#checkWalletFlag';
const clsReviewOrder = '.review-order';
const valuePRSUP =
  'Final costs will be determined after the health insurance claim for your order has been filed. Any patient responsibility will be determined at that time.';
const valueINSUP =
  'Final costs will be determined after the health insurance claim for your order has been filed. Any non-covered amount is included in this total.';
const ordertotalErrorMessage = '.order-total-errorMessage';
const orderError = '.orderError';
const orderTotalTable = '.order-total-table';
const errorMessageDiv = '.errorMessage-div';
const crdebit = 'CRDEBIT';
const ach = 'ACH';
const invalidPaymentMethod = '.invalidPaymentMethod';
const paymentMethodErrorMessageDiv = '.payment-method-errorMessage-div';
const paymentMethodErrorMessage = '.payment-method-errorMessage';
const paymentOption__account = '.payment-option__account';
const paymentOptions__HRA = '.payment-options__HRA';
const paymentOptions__other = '.payment-options__other';
const paymentOptionMessage = '.payment-option-message';
const noPaymenRequired = '.no-payment-required';
const checkout_paymentLoadingMessage = '.checkout_payment-loading-message';
const suppressionCodeValue = '.suppressionCode-value';
const suppressionCode = '.suppressionCode';
const prsup = 'PRSUP';
const insup = 'INSUP';
const totalTradeInCreditAmountValue = '.totalTradeInCreditAmount-value';
const totalTradeInCreditAmount = '.totalTradeInCreditAmount';
const expectedOrderTotalValue = '.expectedOrderTotal-value';
const deliveryCostValue = '.deliveryCost-value';
const totalTaxValue = '.totalTax-value';
const totalCashPriceValue = '.totalCashPrice-value';
const totalCashPrice = '.totalCashPrice';
const totalCoInsuranceValue = '.totalCoInsurance-value';
const totalCoInsurance = '.totalCoInsurance';
const totalCoPayValue = '.totalCoPay-value';
const totalCoPay = '.totalCoPay';
const totalDeductibleValue = '.totalDeductible-value';
const totalDeductible = '.totalDeductible';
const getCardDetailsUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPaymentMethods.getCardData}`;
const completeDetails = '#completeButton';
const errorTextChase = '.error-text-chase';
const stickyCartOrderTotal = '.sticky-cart-total';
const stickyCartSubTotal = '.sticky-cart-sub-total';
const stickyCartTax = '.sticky-cart-tax';
const stickyCartLineItemPrice = '.price';
const stickyCartDelivery = '.sticky-container-delivery';
let errorFlag;
let paymentModeOption = '';
let paymentModeOptionDropdown = '';
let cardDetails = [];
let selectedCardIndex = 0;
let revSpringModalFlag = true;
let paymentOptionSelected;
let checkoutPaymentEditCardAjaxReq = true;
let checkoutPaymentTermsConditionsAjaxReq = true;
let stickyCartTotalValue = 0;
let stickyCartSubTotalValue;
let stickyCartTaxValue = 0;
let stickyCartDeliverChargeValue = 0;
let nextStepButtonForm = false;
let isCardbeingRemoved = false;
const invalidDate =
  'Expiration date is invalid, please re-enter and try again.';
const InvalidCard =
  'Missing or invalid credit card number. Please verify and try again.';
const InvalidCvc = 'Invalid CVC code. Please verify and try again.';
const missingCvc = 'Missing CVC code. Please provide a CVC code and try again.';
const missingName = "Cardholder's name is required.";

const checkoutPaymentMethod = {
  getWalletDetails() {
    const url = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPaymentMethods.getWallet}`;
    const data = {
      payment_mode: paymentModeOption
    };
    jsonGet(url, data).then(response => {
      const status = response.status;
      $(clsPreselected).html('');
      if (status === success) {
        let dropdownVal = '';
        cardDetails = response.paymentInfoDataList;
        $.each(cardDetails, (i, cardInfoDetails) => {
          let content;
          const year = `${cardInfoDetails.cardExpirationYear}`.slice(-2);
          content = `${cardInfoDetails.cardType} ****${cardInfoDetails.cardAccountNumber} ${cardInfoDetails.cardExpirationMonth}/${year}`;
          if (cardDetails.length < 2 && i === 0) {
            $(clsPreselected).html(`${content}<span class="caret"></span>`);
            $(clsReview).attr('disabled', false);
          } else {
            $(clsPreselected).html(`&nbsp;<span class="caret"></span>`);
          }
          dropdownVal += `<li class="items itemsLength"  data-card-details='${i}'>${content}</li>`;
        });
        $(paymentModeOptionDropdown).html(dropdownVal);
        if ($('.itemsLength').length > 4) {
          $(clsCreditDropdown).addClass('dropDownHeight');
        }
        $(pmtOptionCard)
          .find(editButton)
          .removeClass(clsHidden);
        $(pmtOptionCard)
          .find(removeButton)
          .removeClass(clsHidden);
        paymentOptionSelected.find(clsPaymentMethod).removeClass(clsHidden);
      } else if (status === error && revSpringModalFlag) {
        /**
         * Revspring modal has to open automatically when the card details is empty.
         * While closing the revspring modal getwallet details will get called
         * so keeping this revSpringModalFlag to avoid infinte calling of the revspring
         */
        $(pmtOptionCard)
          .find(editButton)
          .removeClass(clsHidden);
        $(pmtOptionCard)
          .find(removeButton)
          .removeClass(clsHidden);
      } else {
        /**
         * If user close the Rev Spring modal without adding any card
         * then need to show initial view of payment method
         */
        if (status !== error) {
          checkoutPaymentMethod.showErrorMessage(response);
        } else {
          paymentOptionSelected.find(clsPaymentMethod).addClass(clsHidden);
          $(clsReview).attr('disabled', true);
        }
      }
    });
  },
  showErrorMessage({ errorMessage }) {
    $(`${clsCheckoutPayment} ${clsRadioContainer}`).addClass(clsHidden);
    $(clsPaymentMessage)
      .html(errorMessage)
      .addClass(`${clsErrorMessage} alert-error`);
    $(clsReview).attr('disabled', false);
  },
  noPaymentFound({ errorMessage }) {
    const errorMsgSection = paymentOptionSelected.find(clsPaymentErrorMessage);
    errorMsgSection.removeClass(clsHidden);
    errorMsgSection.html(errorMessage).addClass(clsErrorMessage);
    $(clsReview).attr('disabled', true);
    paymentOptionSelected.find(clsPaymentMethod).addClass(clsHidden);
  },
  paymentInfoMessage(msg) {
    $(clsPaymentInfo).html(msg);
  },

  viewEditablePaymentSection() {
    const $radioButtonParent = $(this).parents(clsPaymentSection);
    const $parentSection = $(this).parents(clsRadioContainer);
    const radioText = $radioButtonParent.find(clsRadio).val();
    const infoMessage = $radioButtonParent.find(clsRadio).attr(dataInfoMessage);
    paymentOptionSelected = $radioButtonParent;
    revSpringModalFlag = true;
    checkoutPaymentMethod.paymentInfoMessage(infoMessage);
    $parentSection.find(clsPaymentErrorMessage).addClass(clsHidden);
    $parentSection.find(clsPaymentMethod).addClass(clsHidden);
    $parentSection.find(editButton).addClass(clsHidden);
    $parentSection.find(removeButton).addClass(clsHidden);
    $(clsTerms).addClass(clsHidden);
    $('.payment-options__HRA').addClass('padding_top_HRA');
    if (radioText === credit) {
      paymentModeOption = creditMode;
      paymentModeOptionDropdown = clsCreditDropdown;
      checkoutPaymentMethod.getWalletDetails();
    } else if (radioText === hra) {
      paymentModeOption = hra;
      $(clsReview).attr('disabled', radioText === eCheck);
    } else {
      paymentModeOption = statement;
      paymentOptionSelected.find(clsPaymentMethod).removeClass(clsHidden);
      $(clsReview).attr('disabled', radioText === eCheck);
    }
  },

  enableReviewOrder() {
    if (!paymentOptionSelected.find(clsPaymentMethod).hasClass(clsHidden)) {
      $(clsReview).attr('disabled', !$(clsTermsCheckbox).is(':checked'));
    }
  },
  editCard() {
    $(clsPaymentErrorMessage).html('');
    $(clsReview).attr('disabled', true);
    const editUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPaymentMethods.addToWallet}`;
    if (!checkoutPaymentEditCardAjaxReq) return false;
    checkoutPaymentEditCardAjaxReq = false;
    jsonGet(editUrl)
      .then(revResponse => {
        checkoutPaymentEditCardAjaxReq = true;
        const revSpringUrl = revResponse.webTokenLink;
        if (!!revSpringUrl) {
          checkoutPaymentMethod.openRevSpringModal(revSpringUrl);
        } else {
          revSpringModalFlag = false;
          paymentModeOption = 'undetermined';
          checkoutPaymentMethod.showErrorMessage(revResponse);
        }
      })

      .catch(error => {
        checkoutPaymentEditCardAjaxReq = true;
      });
  },
  removeCreditCard(){
    var cboxOptions = {
      maxWidthLg: '380px',
      maxHeightLg: '400px',
      maxWidthMd: '450px',
      maxHeightMd: '400px',
      maxWidthSm: '320px',
      maxHeightSm: 'auto'
    };
    function checkWidth() {
      if (window.innerWidth < 376) {
        return cboxOptions.maxWidthSm;
      }  else {
        return cboxOptions.maxWidthMd;
      }
    };
    $.colorbox.resize()
    if(selectedCardIndex){
      $('#selectedWalletId').val(cardDetails[selectedCardIndex].walletId)
      ACC.colorbox.open('', {
        escKey: false,
        overlayClose: false,
        closeButton: true,
        html: $('#removeCreditCardModal').html(),
        onLoad: $('#cboxOverlay').css('position', 'fixed'),
        width: checkWidth(),
        height: cboxOptions.maxHeightMd,
        className: 'removeCreditCardModal',
        onClosed: function() {
          $('.selected-card-remove-btn').prop("disabled",false);
          ACC.colorbox.close();
        }
      });

    }
    else{
      alert("Please select a credit card")
    }
  },
  assignFormValues(selectedCardDetails) {
    $(paymentOption).val('CARD');
    $(walletId).val(selectedCardDetails.walletId);
    $(cardNetwork).val(selectedCardDetails.cardType);
    $(cardAccountNumber).val(selectedCardDetails.cardAccountNumber);
    $(cardAccountHolderName).val(selectedCardDetails.cardAccountHolderName);
    $(cardCardType).val(selectedCardDetails.cardCardType);
    $(financialInstitution).val(selectedCardDetails.financialInstitution);
  },

  submitReviewOrderForm() {
    let getOrderTotal = $(orderTotal).attr('data-order');
    if (paymentModeOption === hra) {
      $(paymentOption).val(hra);
    } else if (paymentModeOption === statement) {
      $(paymentOption).val(statement);
    } else if (
      paymentModeOption === '' ||
      getOrderTotal === nullOrder ||
      paymentModeOption === 'undetermined'
    ) {
      const getError = $('.orderError').attr('data-error');
      if (getError) {
        $(paymentOption).val(undetermined);
      } else {
        if (paymentModeOption === 'undetermined') {
          $(paymentOption).val(undetermined);
        } else {
          $(paymentOption).val('');
        }
      }
    } else {
      const selectedCardDetails = cardDetails[selectedCardIndex];
      if (!!selectedCardDetails) {
        if (paymentModeOption === creditMode) {
          checkoutPaymentMethod.assignFormValues(selectedCardDetails);
          $(cardExpirationMonth).val(selectedCardDetails.cardExpirationMonth);
          $(cardExpirationYear).val(selectedCardDetails.cardExpirationYear);
        }
      } else {
        $(paymentOption).val(undetermined);
      }
    }
    let referralCode = window.sessionStorage.getItem('referralCode');
         if (referralCode != null) {
          $('#referralCode_id').val(referralCode);
    }
    if(!nextStepButtonForm){
      nextStepButtonForm = true;
      $(reviewOrderForm).submit();
    }
  },

  openRevSpringModal(url) {
    $(clsRevSpringContainer).attr('src', url);
    $(clsPaymentOrderContainer).addClass('hidden');
    $(clsChaseContainer).removeClass('hidden');
    $(clsChaseContainer)
      .find(clsChaseErrorMessage)
      .text('');
    $(clsChaseContainer)
      .find(clsChaseErrorContainer)
      .addClass(constHidden);
    $(clsReviewOrder).addClass(constHidden);
  },

  checkWallet() {
    revSpringModalFlag = false;
    paymentOptionSelected.find(clsPaymentErrorMessage).addClass(clsHidden);
    checkoutPaymentMethod.getWalletDetails();
    $(clsCheckWalletFlag).val('false');
  },
  addCardEnter(e) {
    if (e.keyCode === 13) {
      $(this).trigger('click');
    }
  },
  changedropDownValue() {
    selectedCardIndex = $(this).attr('data-card-details');
    $(clsPreselected).html($(this).text() + '<span class="caret"></span>');
    $(clsReview).attr('disabled', false);
  },

  showTermsCondition(e) {
    e.preventDefault();
    const termAndConditionUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPaymentMethods.termsAndConditions}`;
    if (!checkoutPaymentTermsConditionsAjaxReq) return false;
    checkoutPaymentTermsConditionsAjaxReq = false;
    htmlGet(termAndConditionUrl)
      .then(responseData => {
        checkoutPaymentTermsConditionsAjaxReq = true;
        const response = ACC.sanitizer.sanitizeHtmlDeeply(responseData);
        $('.terms-condition-container').html(response);
        ACC.colorbox.open('', {
          html: $(clsTermsCondition).html(),
          onLoad: $(cboxOverlay).css('position', 'fixed'),
          width: checkWidth(),
          height: checkHeight(),
          onClosed: function() {
            ACC.colorbox.close();
          }
        });
      })
      .catch(error => {
        checkoutPaymentTermsConditionsAjaxReq = true;
      });
    $(cboxTitle).remove();
    $(cboxParent)
      .find(clsTermConditionModal)
      .parents(cboxLoadedContent)
      .addClass(clsTermConditionParent);
  },

  formatCardDetails(e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  },
  backToPreviousPage() {
    $(clsReviewOrder).removeClass('hidden');
    $(clsPaymentOrderContainer).removeClass('hidden');
    $(clsChaseContainer).addClass('hidden');
  },

  getCompleteDetails() {
    checkoutPaymentMethod.paymentErrors();
    const paymentForm = $('#theForm').serialize();
    if (errorFlag) {
      $.ajax({
        type: 'POST',
        url: getCardDetailsUrl,
        data: paymentForm,
        success: function(response) {
          checkoutPaymentMethod.getWalletDetails();
          checkoutPaymentMethod.backToPreviousPage();
        }
      }).fail(function() {
        console.log('not submitted');
      });
    }
  },

  addErrorMsg(errorText) {
    let errorTextCode =
      '<span class="svg-icon_alert_fill_red svg-icon_alert_fill_red-dims alertImg mb-3"></span>' +
      '<span class="chase-error-text pt-1 pl-2" role="alert">' +
      errorText +
      '</br>' +
      '</span>';
    $(clsChaseContainer)
      .find(errorTextChase)
      .append(errorTextCode);
    $(clsChaseContainer)
      .find(clsChaseErrorContainer)
      .removeClass(constHidden);
  },

  paymentErrors() {
    $(clsChaseContainer)
      .find(clsChaseErrorContainer)
      .addClass(constHidden);
    errorFlag = true;
    const getCustCvv = $('#cvv2').val();
    const getName = $('#custName').val();
    const getCardNumber = $('#ccNumber').val();
    $('.error-text-chase')
      .find('span')
      .remove();
    const getMonth = $('#expMonth')
      .find(':selected')
      .text();
    const getYear = $('#expYear')
      .find(':selected')
      .text();
    $('#expYear').selectmenu('refresh');
    $('#expMonth').selectmenu('refresh');
    const date = new Date();
    const parsedDate = ''
      .concat(date.getFullYear(), '-')
      .concat(date.getMonth() + 1);
    const selectDate = ''.concat(getYear, '-').concat(getMonth);
    let date1 = new Date(selectDate);
    let date2 = new Date(parsedDate);
    if (date2 > date1 && date2 !== date1) {
      errorFlag = false;
      checkoutPaymentMethod.addErrorMsg(invalidDate);
    }
    if (getCardNumber === '' || getCardNumber.length < 16) {
      errorFlag = false;
      checkoutPaymentMethod.addErrorMsg(InvalidCard);
    }
    if (getCustCvv.length < 3 && getCustCvv !== '') {
      errorFlag = false;
      checkoutPaymentMethod.addErrorMsg(InvalidCvc);
    }
    if (getCustCvv === '') {
      errorFlag = false;
      checkoutPaymentMethod.addErrorMsg(missingCvc);
    }
    if (getName === '') {
      errorFlag = false;
      checkoutPaymentMethod.addErrorMsg(missingName);
    }
  },
  whatsThis() {
    alert('The 3 numbers on the back of your card.');
  },
  removeCreditCardConfirmation(){
	  if (isCardbeingRemoved) {
		  return;
	  }
	  isCardbeingRemoved = true;
  let selectedwalletID = $('#selectedWalletId').val()
    $.ajax({
      type: 'POST',
      url: `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPaymentMethods.removeCreditCard}`,
      dataType: 'json',
      contentType : 'application/json',
      data: JSON.stringify({subscriptionId:selectedwalletID}),
      success: function(data) {
        if(data.status == '200'){
          $('.selected-card-remove-btn').prop("disabled",false);
          $('.api-error-field').addClass('hidden');
          ACC.colorbox.close();
          location.reload();
        }else{
          //display error msg in the modal
          let hght = $("#cboxLoadedContent").height() + 20;
          $("#cboxLoadedContent").height(hght);
          $('.api-error-field').removeClass('hidden').text(data.message);
		  isCardbeingRemoved = false;
        }
      },
      error:function(err){
        $('.selected-card-remove-btn').prop("disabled",true);
		isCardbeingRemoved = false;
      }
    });
  },

  init() {
    $doc.on('click', completeDetails, this.getCompleteDetails);
    $doc.on('keypress keyup', '.cardDetails', this.formatCardDetails);
    $('#expMonth,#expYear,#ccType').selectmenu();
    $doc.on('click', '#cancelButton', this.backToPreviousPage);
    $doc.on('click', '.creCVV2WhatLink', this.whatsThis);
    $doc.on('click', clsRadio, this.viewEditablePaymentSection);
    $doc.on('click', editButton, this.editCard);
    $doc.on('click', reviewButton, this.submitReviewOrderForm);
    $doc.on('click', clsTermsCheckbox, this.enableReviewOrder);
    $doc.on('click', clsDropdown, this.changedropDownValue);
    $doc.on('click', clsShowTermsCondition, this.showTermsCondition);
    $doc.on('change', clsCheckWalletFlag, this.checkWallet);
    $doc.on('keyup', '.addCard-button', this.addCardEnter);
    $doc.on('click',removeButton,this.removeCreditCard);
    $doc.on('click', '.selected-card-remove-btn', this.removeCreditCardConfirmation);
    $doc.on('click', '.selected-card-cancel-btn', function() {
      $('.selected-card-remove-btn').prop("disabled",false);
        ACC.colorbox.close();
      }
    );

    $(window).resize(function() {
      if ($('.remove-creditCard-modal-body')) {
        $.colorbox.resize({
          width: checkWidth()
        });
      }
    });
    if (
      window.location.href.indexOf('payment-method') !== -1 &&
      window.location.href.indexOf('add') !== 1
    ) {
      const getOrderTotalAndPaymentOptUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPaymentMethods.getOrderTotalAndPaymentOpt}`;
      htmlGet(getOrderTotalAndPaymentOptUrl)
        .then(response => {
          var data = JSON.parse(response);
          var orderTotal = data.orderTotal;
          if (orderTotal.errorMessage) {
            $(ordertotalErrorMessage).text(orderTotal.errorMessage);
            $(orderError).attr('data-error', orderTotal.errorMessage);
            $(orderTotalTable).addClass('hidden');
            $(errorMessageDiv).removeClass('hidden');
            $(clsReview).attr('disabled', true);
            $(checkout_paymentLoadingMessage).addClass('hidden');
            return;
          } else {
            if (orderTotal.totalDeductible !== null) {
              $(totalDeductible).removeClass('hidden');
              $(totalDeductibleValue).text(
                orderTotal.totalDeductible.toFixed(2)
              );
            }
            if (orderTotal.totalCoPay !== null) {
              $(totalCoPay).removeClass('hidden');
              $(totalCoPayValue).text(orderTotal.totalCoPay.toFixed(2));
            }
            if (orderTotal.totalCoInsurance !== null) {
              $(totalCoInsurance).removeClass('hidden');
              $(totalCoInsuranceValue).text(
                orderTotal.totalCoInsurance.toFixed(2)
              );
            }
            if (orderTotal.totalCashPrice !== null) {
              $(totalCashPrice).removeClass('hidden');
              $(totalCashPriceValue).text(orderTotal.totalCashPrice.toFixed(2));
            }

            if (orderTotal.totalTax !== null) {
              $(totalTaxValue).text(orderTotal.totalTax.toFixed(2));
              $(stickyCartTax).text('$' + orderTotal.totalTax.toFixed(2));
            }

            if (orderTotal.deliveryCost !== null) {
              $(deliveryCostValue).text(orderTotal.deliveryCost.toFixed(2));
              if (orderTotal.deliveryCost !== 0) {
                $(stickyCartDelivery).text(
                  '$' + orderTotal.deliveryCost.toFixed(2)
                );
              }
            }

            if (orderTotal.expectedOrderTotal !== null) {
              $(expectedOrderTotalValue).text(
                orderTotal.expectedOrderTotal.toFixed(2)
              );
              $(stickyCartOrderTotal).text(
                orderTotal.expectedOrderTotal.toFixed(2)
              );
            }

            if (
              orderTotal.lines !== undefined &&
              orderTotal.lines !== null &&
              orderTotal.lines.length > 0
            ) {
              let entryMap = new Map();
              orderTotal.lines.map(function(element, index) {
                entryMap.set(element.entryNumber, element.basePrice);
              });
              $(stickyCartLineItemPrice).each(function(i) {
                if (entryMap.get(`${i}`) !== null) {
                  $(this).text('$' + entryMap.get(`${i}`).toFixed(2));
                }
              });
            }

            $(orderTotal).attr('data-order', orderTotal.expectedOrderTotal);

            if (orderTotal.totalTradeInCreditAmount) {
              $(totalTradeInCreditAmount).removeClass('hidden');
              $(totalTradeInCreditAmountValue).text(
                '$' + orderTotal.totalTradeInCreditAmount.toFixed(2)
              );
            }

            if (
              orderTotal.suppressionCode &&
              (orderTotal.suppressionCode === prsup ||
                orderTotal.suppressionCode === insup)
            ) {
              $(suppressionCode).removeClass('hidden');
              if (orderTotal.suppressionCode === prsup) {
                $(suppressionCodeValue).text(valuePRSUP);
              }
              if (orderTotal.suppressionCode === insup) {
                $(suppressionCodeValue).text(valueINSUP);
              }
            }

            if (orderTotal.expectedOrderTotal !== null) {
              stickyCartTotalValue = `${orderTotal.expectedOrderTotal}`;
            }
            if (orderTotal.deliveryCost !== null) {
              stickyCartDeliverChargeValue = `${orderTotal.deliveryCost}`;
            }
            if (orderTotal.totalTax !== null) {
              stickyCartTaxValue = `${orderTotal.totalTax}`;
            }
            stickyCartSubTotalValue =
              stickyCartTotalValue -
              stickyCartDeliverChargeValue -
              stickyCartTaxValue;
            $(stickyCartSubTotal).text(stickyCartSubTotalValue.toFixed(2));
          }

          if (data.invalidPaymentMethod) {
            $(invalidPaymentMethod).removeClass('hidden');
          }
          if (data.paymentData !== null) {
            if (data.paymentData.errorMessage) {
              $(paymentMethodErrorMessageDiv).removeClass('hidden');
              $(paymentMethodErrorMessage).text(data.paymentData.errorMessage);
              $(orderError).attr('data-error', data.paymentData.errorMessage);
              $(clsReview).attr('disabled', true);
            } else {
              if (data.paymentData) {
                data.paymentData.paymentOptions.forEach(element => {
                  if (element.paymentTypeCode === crdebit) {
                    $(pmtOptionCard).removeClass('hidden');
                    $('.payment-option__card .payment-options__label').text(
                      element.paymentTypeDescription
                    );
                  }
                  if (element.paymentTypeCode === ach) {
                    $(paymentOption__account).removeClass('hidden');
                    $('.payment-option__account .payment-options__label').text(
                      element.paymentTypeDescription
                    );
                  }
                  if (element.paymentTypeCode === hra) {
                    $(paymentOptions__HRA).removeClass('hidden');
                    $('.payment-options__HRA .payment-options__label').text(
                      element.paymentTypeDescription
                    );
                  }
                });
                if (
                  data.paymentData.otherOptions !== null &&
                  data.paymentData.otherOptions.length > 0
                ) {
                  $(paymentOptions__other).removeClass('hidden');
                }
                $(clsReview).attr('disabled', true);
              } else {
                $(paymentOptionMessage).addClass('hidden');
                $(noPaymenRequired).removeClass('hidden');
              }
            }
          } else {
            $(noPaymenRequired).removeClass('hidden');
            $(clsReview).attr('disabled', false);
            $(paymentOptionMessage).addClass('hidden');
          }

          $(checkout_paymentLoadingMessage).addClass('hidden');
          $(clsCheckoutPayment).removeClass('hidden');
        })
        .catch(error => {
          $(window).scrollTop(0);
          $('.global-error-message-container .generic-error-text').text(
            error.errorMessage
          );
          $('.global-error-message-container').removeClass('hidden');
        });
    }
  }
};
checkoutPaymentMethod.init();

export default checkoutPaymentMethod;
